import React from 'react';
import { Body } from '../Typography/Body.esm.js';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';
import '@headlessui/react';
import '../../utils/constants.esm.js';
import { CaretRightIcon, CaretDownIcon } from '@panwds/icons';

const TreeNode = (props) => {
    var _a;
    const { dataMetrics, dataTestId, item, hasChildren, level, onToggle, selected, } = props;
    return (React.createElement("li", { "data-metrics": dataMetrics, "data-testid": dataTestId || `tree-node-${testIdGen(item.label)}`, className: `tw-box-border tw-flex tw-items-center tw-cursor-pointer tw-m-2 tw-animate-fadeIn`, style: { paddingLeft: `${level * 16}px` }, onClick: onToggle },
        React.createElement(Body, null, (_a = item.content) !== null && _a !== void 0 ? _a : item.label),
        hasChildren && !selected && (React.createElement(CaretRightIcon, { className: `tw-pl-2`, size: "xs" })),
        hasChildren && selected && (React.createElement(CaretDownIcon, { className: `tw-pl-2`, size: "xs" }))));
};

export { TreeNode as default };
//# sourceMappingURL=TreeNode.esm.js.map
